import React, { useContext, useMemo } from 'react';
import { VehicleDetails } from '../../types';
import PriceLabel from '../PriceLabel';
import LegalText from '../LegalText';
import { vehicleContext } from '../VehicleProvider';
import {
  ModelContainer,
  ModelPriceLabel,
  ModelPrice,
  LegalTextContainer,
} from './DealerPriceInfo.style';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const PriceInfoT1 = () => {
  const { vehicle } = useContext(vehicleContext);
  const { modelPrice, modelPriceRetail, market, isAvailableNow, vehicleType } =
    (vehicle as VehicleDetails) ?? {};

  const isMarketUSA = market.includes('us');

  const correctPrice = useMemo(() => {
    if (isMarketUSA && !isAvailableNow && vehicleType === 'new') return 'Available soon';
    if (isMarketUSA) return `$${modelPrice}`;
    return modelPriceRetail;
  }, [isAvailableNow, isMarketUSA, modelPrice, modelPriceRetail, vehicleType]);

  return (
    <ModelContainer>
      {/* When Market is Canada, we only show one Price and that price would be modelPrice */}
      {/* When Market is US and Tier 1 we only show one Price */}
      {/* And That value will be 'modelPrice' and the copy will be 'Msrp+destination fee ..' */}
      <ModelPriceLabel data-testid="price-label">
        <PriceLabel />
        <ModelPrice data-vehicle-price={modelPrice} data-testid="model-price">
          {correctPrice}*
        </ModelPrice>
      </ModelPriceLabel>
      <LegalTextContainer data-testid="price-legal-text">
        * <LegalText />
      </LegalTextContainer>
    </ModelContainer>
  );
};

export default PriceInfoT1;
